import React from 'react';
import { getFormattedTime } from '../calendarHelper.js';
import './EventDisplay.css'

export default class EventItem extends React.PureComponent {
  render() {
    const {event, singleTeamView, time} = this.props;
    let team = null;
    if (event._embedded) {
      team = event._embedded.team;
    }


    const isMeeting =  event.event_type === 'meeting';
    let check_if_college = team && team.team_type === 'college';
    let sportLevel = null;
    let teamLogoUrl = null;
    let teamAwayLogo = null;
    let gameIsScored = null;
    let scoreOrder = null;
    let highSchoolEventPlace = null;
    let streaming_url = null
    if (event.streaming_url) {
      streaming_url = event.streaming_url
    } else if (event._embedded.team && event._embedded.team.streaming_url && event.event_type === "game")  {
      streaming_url = event._embedded.team.streaming_url
    }

    if (event.place_name.toLowerCase().includes('high school')) {
      highSchoolEventPlace = event.place_name.slice(0, -12) + ' HS'
    }
    const eventField = event._links.game ? event._embedded.game.location.field_name : event.field;
    const eventPlace = highSchoolEventPlace || event.place_name;

    const networkTypes = ['school', 'club', 'band', 'team'];
    for (const networkType of networkTypes) {
      if (networkType in event._embedded) {
        if (networkType === 'club' || networkType === 'band') {
          sportLevel = event._embedded[networkType].name;
          teamLogoUrl = event._embedded[networkType]._links.profile_picture.href;
        } else if (networkType === 'team') {
          sportLevel = event._embedded[networkType].team_title;
          teamLogoUrl = event._embedded[networkType]._links.profile_thumbnail.href;
        } else if (networkType === 'school') {
          sportLevel = event._embedded[networkType].name;
          teamLogoUrl = event._embedded[networkType]._links.profile_picture.href;
        }
      }
    }
    let eventTypeClass = null;
    let eventHref = event._links.self.href;
    if (event.recurring && event.eventZoneOccurrenceDate) {
      // av_date is an identity key matched server-side against occurrence dates in the event's timezone.
      eventHref += '?av_date=' + event.eventZoneOccurrenceDate;
    }
    let eventTitle = (<a href={eventHref} className="">
      {event.title}
    </a>);
    let eventLink = (<a href={eventHref} className="u-defaultLinkColor">
      Event Info
    </a>);
    if (event.event_type === "practice") {
      eventLink = (<a href={eventHref} className="u-defaultLinkColor">
        Practice Info
      </a>);
    } else if (event.event_type === "meeting") {
      eventLink = (<a href={eventHref} className="u-defaultLinkColor">
        Meeting Info
      </a>);
    }

    let gameScore, teamlogoLink, isHomeTeam;
    if (event.event_type === 'tba_game') {
      eventLink = (<a href={eventHref} className="u-defaultLinkColor">
        Game Info
      </a>);
    }
    if ( event._links.game ) {
      const game = event._embedded?.game;
      const team = event._embedded?.team
      eventTitle = game.display_name_shortest;
      eventHref = event._links.game.href;
      eventLink = (<a href={event._links.game.href} className="u-defaultLinkColor">
        Game Info
      </a>);
      gameIsScored = !game.unscored
      isHomeTeam = game.team_a_id === game.home_team_id;
      scoreOrder = (<span
        className="bold"> {(isHomeTeam && !team.sport_id === 8) || isHomeTeam ? `${game.home_team_score} - ${game.away_team_score}` : `${game.away_team_score} - ${game.home_team_score}`}</span>)
      if (game.final_scored) {
        const { home_team_score, away_team_score } = game;
        const isWin = home_team_score < away_team_score && team.sport_id === 8 ||
          home_team_score > away_team_score && team.sport_id !== 8;

        const isLoss = home_team_score > away_team_score && team.sport_id === 8 ||
          home_team_score < away_team_score && team.sport_id !== 8;

        const isTied = home_team_score === away_team_score;

        if (isWin) {
          gameScore = (
            <span className={isHomeTeam ? "text-success" : "text-danger"}>
        {isHomeTeam ? "W" : "L"}
      </span>
          );
        } else if (isLoss) {
          gameScore = (
            <span className={isHomeTeam ? "text-danger" : "text-success"}>
        {isHomeTeam ? "L" : "W"}
      </span>
          );
        } else if (isTied) {
          gameScore = (<span className="u-tied">T</span>);
        }
      }

      if (isHomeTeam) {
        teamlogoLink = game._links.away_team_profile_picture.href
        if (!singleTeamView) {
          // teamlogoLink = game._links.home_team_profile_picture.href
          teamAwayLogo = game._links.home_team_profile_picture.href
          eventTitle = (<a href={eventHref}>
            <table className="table table-borderless u-defaultLinkColor u-collapseHead m-0 CalendarTable">
              <thead>
              <tr>
                <th>Team Name</th>
                <th></th>
                <th>Score</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className="col light CreatEllipsis">{game.away_team_short_name}</td>
                <td className="col-1"></td>
                <td className="text-center text-dark">{game.away_team_score ?? null}</td>
              </tr>
              <tr>
                <td className="col light CreatEllipsis">{game.home_team_short_name}</td>
                <td className="col-1"></td>
                <td className="col-md-3 col-lg-1 text-center text-dark">{game.home_team_score ?? null}</td>
              </tr>
              </tbody>
            </table>
          </a>);
        } else {
          eventTitle = (<a href={eventHref} className="">
            {game.away_team_short_name} {(check_if_college || game.level === "Varsity") ? null : ''}
          </a>);
        }
      } else {
        teamlogoLink = game._links.home_team_profile_picture.href
        if (!singleTeamView) {
          teamlogoLink = game._links.away_team_profile_picture.href
          teamAwayLogo = game._links.home_team_profile_picture.href
          eventTitle = (<a href={eventHref}>
            <table className="table table-borderless u-collapseHead  u-defaultLinkColor m-0 CalendarTable">
              <thead>
                <tr>
                  <th>Team Name</th>
                  <th></th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="col light CreatEllipsis">{game.away_team_short_name}</td>
                  <td className="col-1"></td>
                  <td className="text-center text-dark">{game.away_team_score ?? null}</td>
                </tr>
                <tr>
                  <td className="col light CreatEllipsis">{game.home_team_short_name}</td>
                  <td className="col-1"></td>
                  <td className="col-md-3 col-lg-1 text-center text-dark">{game.home_team_score ?? null}</td>
                </tr>
              </tbody>
            </table>
          </a>);
        } else {
          eventTitle = (<a href={eventHref} className="">
            {game.home_team_short_name} {(check_if_college || game.level === "Varsity") ? null : ''}
          </a>);
        }
      }
    } else if (event._links.combine) {
      eventTitle = (<a href={eventHref} className="">
        {event.title}
      </a>);
      eventHref = event._links.combine.href;
      eventLink = (<a href={event._links.combine.href} className="u-defaultLinkColor">
        More Info
      </a>);
    }

    if (event.event_type === "general" || event.event_type === "combine") {
      eventTypeClass = "event"
    }
    let streamingLink = null;
    if (streaming_url && !event.cancelled && !gameScore) {
      streamingLink = (
        <div className="row m-0">
          <div className="col"></div>
          <div className="col text-center">
            <a className="u-defaultLinkColor" target="_blank" rel="noopener noreferrer" href={streaming_url}>
              {isMeeting ? 'Meeting Link' : 'Streaming'}
            </a>
          </div>
          <div className="col"></div>
        </div>
      );
    }
    if (!singleTeamView && event._links.game ) {
      return (
        <div className="border-bottom py-1">
          <p className="EventTime text-start m-0 px-2">
            {getFormattedTime(event.local_iso8601, event.tzid)}
          </p>
          <div
            className={`EventInfo--container d-flex flex-nowrap EventType ${eventTypeClass || event.event_type}-indicator m-2`}>
            <div className="ms-1 me-2 d-flex flex-column gap-1">
              <a href={eventHref}>
                <img className="TeamLogo-twoTeam d-md-none d-lg-block" src={teamlogoLink} alt="Team Logo"/>
              </a>
              <a href={eventHref}>
                <img className="TeamLogo-twoTeam d-md-none d-lg-block" src={teamAwayLogo} alt="Team Logo"/>
              </a>
            </div>
            <div className="col EventInfo" style={{textDecorationLine: event.cancelled ? 'line-through' : ''}}>
              {eventTitle}
              {team && <p>{sportLevel} </p>}
              <p className="d-flex justify-content-between">
                <span className="CreatEllipsis">
                  {eventPlace && `${eventPlace}`}{eventPlace && eventField && ' - '}{eventField}
                </span>
                {}
                <span className="text-nowrap text-end"> {eventLink} </span>
              </p>
            </div>
          </div>
          {streamingLink}
        </div>
      )
    }
    let displayTime =  getFormattedTime(event.local_iso8601, event.tzid);
    if (event.event_type === 'tba_game') {
      displayTime = 'TBA';
    } else if (event.multi_day && event.final_day && !event.ends_date_only) {
      // ends_date_only (volunteer items only) means the underlying end has
      // no real time of day (see Volunteers::Slot#ends_date_only?) — falls
      // through to the 'All Day' branch below instead of printing the
      // literal sentinel time, the same label every OTHER day of this
      // item's span already gets.
      const localEndDate = new Date(event.local_end_iso8601);
      displayTime = 'Ends at ' + getFormattedTime(localEndDate, event.tzid);
    } else if (event.multi_day || event.all_day) {
      displayTime = 'All Day';
    }
    return (
      <div className="border-bottom py-1">
        <p className="EventTime text-start m-0 px-2">
          {displayTime}
        </p>
        <div
          className={`EventInfo--container d-flex flex-nowrap EventType ${eventTypeClass || event.event_type}-indicator m-2`}>
          <div className="d-flex justify-content-center align-items-center me-1">
            {event._links.game ? (<a href={eventHref}>
              <img className="TeamLogo d-md-none d-lg-block" src={teamlogoLink} alt={isHomeTeam !== null ? 'Away Team' : 'Home Team'}/>
            </a>) : (<a href={eventHref}>
              <img className="TeamLogo d-md-none d-lg-block" src={teamLogoUrl} alt="Team Logo"/>
            </a>)}
          </div>
          <div className="col EventInfo" style={{textDecorationLine: event.cancelled ? 'line-through' : ''}}>
            <span className="vsAt mb-0">
              {event._links.game &&
                <span className="me-1">
                {event._links.game ? isHomeTeam !== null ? isHomeTeam ? 'vs' : '@' : '' : ''}
              </span>
              }
              {eventTitle}
            </span>
            {team && <p>{sportLevel} </p>}
            {(eventPlace || eventField) && <p>
              {eventPlace && `${eventPlace}`}{eventPlace && eventField && ' - '}{eventField}
            </p>}
          </div>
          <div className="text-end d-flex flex-column justify-content-between EventMisc">
            <span className="ChildName">
            {/*  child name*/}
            </span>
            <span>
              <span className="me-1">
            {event.cancelled ? '' : event.event_type === 'game' && gameIsScored ? gameScore : '\xa0'}
              </span>
              {event.cancelled ? 'Cancelled' : event.event_type === 'game' && gameIsScored ? scoreOrder : '\xa0'}
            </span>
            {eventLink}
            {event.volunteer_signup_href && <a href={event.volunteer_signup_href} className="u-defaultLinkColor">
              Volunteer
            </a>}
          </div>
        </div>
        {streamingLink}
      </div>
    );
  }
}
